import selectorReducerFor, { selectorInitialState, SelectorState } from '../redux/selector/reducerFor'
import { Environment } from '../../remote-api/models'
import { EnvironmentAction } from './actions'
import { ENVIRONMENT_PREFIX, ENVIRONMENT_RESOURCE_NAME } from './model'

export type EnvironmentSelectorState = SelectorState<Environment>

export const environmentSelectorInitialState = {...selectorInitialState}

export const environmentSelectorReducer = (origin?: string) => {
  const environmentReducerForOrigin = selectorReducerFor<Environment>(ENVIRONMENT_RESOURCE_NAME, ENVIRONMENT_PREFIX, origin)
  return function reducer(state: EnvironmentSelectorState = environmentSelectorInitialState, action: EnvironmentAction): EnvironmentSelectorState {
    return {
      ...state,
      ...environmentReducerForOrigin(state, action)
    }
  }
}
